import { LoadingModule } from "@/components/modules/loading";
import { useGlobalContext } from "@/hooks/use-global-context";
import { useDefaultHomepage } from "@/hooks/use-default-homepage";
import { DEFAULT_HOMEPAGE_PAGES } from "@/constants/homepage";
import { OnboardingModule } from "@/components/modules/onboarding";
import { UserDashboardV4 } from "@/modules/dashboard/v4";
import { WithAppLayoutParams } from "@/components/layouts/app/hoc";

const HomepageWithDataFetched = () => {
  const { isUserLoaded } = useGlobalContext();
  const { defaultPage } = useDefaultHomepage();

  return isUserLoaded ? (
    defaultPage === DEFAULT_HOMEPAGE_PAGES.ONBOARDING ? (
      <OnboardingModule />
    ) : (
      <UserDashboardV4 />
    )
  ) : (
    <LoadingModule />
  );
};

export default WithAppLayoutParams(
  {
    navTitle: null,
    pageContainerClassName: "bg-[#f7f9fa]",
    isBackgroundVisible: false,
  },
  HomepageWithDataFetched
);
